import { Alert, Box, styled } from "@mui/material";

export const InfoSectionContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const InfoAlert = styled(Alert)<{ borderColor: string }>(({ borderColor, theme }) => ({
  "&&": {
    borderLeft: `4px solid ${borderColor}`,
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.text.secondary,
  },
  "& .MuiAlertTitle-root": {
    color: theme.palette.text.primary,
  },
}));
